/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PublishLayer.scss';

import ModalAlert from '../../../ModalAlert';
import { publishLayer, getDistrictData, deleteLayer } from '../../../../../actions/district';

class PublishLayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
    };
  }

  onPublikuj = (e, i) => {
    e.preventDefault();
    this.props
      .publishLayer(this.props.district.prefix, this.props.district.pg_layers[i])
      .then(resp => {
        this.props.getDistrictData(this.props.district.prefix).then(() => {
          this.setState({ modalTitle: 'Status', modalBody: resp.message, showModal: true });
        });
      });
  };

  onDelete = (e, i) => {
    e.preventDefault();
    this.props
      .deleteLayer(this.props.district.prefix, this.props.district.pg_layers[i])
      .then(resp => {
        this.props.getDistrictData(this.props.district.prefix).then(() => {
          this.setState({ modalTitle: 'Status', modalBody: resp, showModal: true });
        });
      });
  };

  dismissModal = () => this.setState({ showModal: false });

  render() {
    return (
      <table className="table">
        <tbody>
          {this.props.district.pg_layers.map((v, i) => {
            const isPublished = _.find(this.props.district.layers, o => o.name === v);
            return !isPublished ? (
              <tr key={i}>
                <td>{String.prototype.normalizeLayerName(v)}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-info"
                    value={i}
                    onClick={e => this.onPublikuj(e, i)}
                  >
                    Publikuj
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    value={i}
                    onClick={e => this.onDelete(e, i)}
                  >
                    Usuń
                  </button>
                </td>
              </tr>
            ) : null;
          })}
        </tbody>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
      </table>
    );
  }
}

const mapState = state => ({
  district: state.district.district,
});
const mapDispatch = {
  publishLayer,
  getDistrictData,
  deleteLayer,
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(PublishLayer),
);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/PublishLayer/PublishLayer.js